import { useState } from "react";
import { API_BASE } from "../api/client";
import { ExternalLink, ImageOff } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";

export function authedFileUrl(fileId) {
  const token = localStorage.getItem("flp.access_token");
  return `${API_BASE}/files/${fileId}${token ? `?auth=${encodeURIComponent(token)}` : ""}`;
}

const Shimmer = () => (
  <div className="absolute inset-0 bg-[#1C202E] overflow-hidden">
    <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
  </div>
);

// `natural`  → show the whole picture uncropped at its natural aspect ratio (Wall feed).
// `thumbFileId` → reduced-resolution variant shown inline; full image loaded on zoom.
export function ProofImage({ fileId, thumbFileId, url, testId, className = "", natural = false }) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [zoom, setZoom] = useState(false);

  if (fileId && !failed) {
    const feedSrc = authedFileUrl(thumbFileId || fileId);
    const fullSrc = authedFileUrl(fileId);
    const img = {
      "data-testid": testId, src: feedSrc, loading: "lazy", decoding: "async", alt: "post",
      onLoad: () => setLoaded(true), onError: () => setFailed(true),
    };
    return (
      <>
        {natural ? (
          <button type="button" onClick={() => setZoom(true)}
            className="relative block w-full min-h-[200px] cursor-zoom-in rounded-lg border border-white/10 bg-[#1C202E] overflow-hidden">
            {!loaded && <Shimmer />}
            <img {...img} className={`relative w-full h-auto max-h-[75vh] object-contain mx-auto transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`} />
          </button>
        ) : (
          <button type="button" onClick={() => setZoom(true)}
            className={`relative shrink-0 rounded-lg border border-white/10 bg-[#1C202E] overflow-hidden cursor-zoom-in ${className}`}>
            {!loaded && <Shimmer />}
            <img {...img} className={`relative h-full w-full object-cover transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`} />
          </button>
        )}
        <Dialog open={zoom} onOpenChange={setZoom}>
          <DialogContent data-testid={`${testId}-preview`} className="bg-[#0B0C13] border-white/10 max-w-3xl p-3">
            <img src={fullSrc} alt="proof" className="max-h-[80vh] w-full object-contain rounded-md" />
          </DialogContent>
        </Dialog>
      </>
    );
  }
  const box = `shrink-0 rounded-lg border border-white/10 bg-white/5 overflow-hidden flex items-center justify-center ${natural ? "w-full aspect-video" : className}`;
  if (url) return <a data-testid={testId} href={url} target="_blank" rel="noreferrer" className={`${box} text-sky-300 hover:text-white`}><ExternalLink className="h-5 w-5" /></a>;
  return <div data-testid={testId} className={`${box} text-slate-500`}><ImageOff className="h-5 w-5" /></div>;
}
